import React from 'react';
import { FormattedMessage } from 'react-intl';

type IsEnabled = {
  value: number;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

type Props = {
  isCommentEnabled: IsEnabled;
  isLandmarkCommentEnabled: IsEnabled;
  isEmojiEnabled: IsEnabled;
  isCommentListEnabled: IsEnabled;
  isLocateEnabled: IsEnabled;
};

const VtourCheck = React.memo((props: Props) => {
  const style: { [key: string]: React.CSSProperties } = {
    div: {
      textAlign: 'center',
      marginBottom: 0,
    },
    text: {
      fontWeight: 'bold',
      marginBottom: '4px',
    },
    ul: {
      width: '320px',
      margin: '0 auto 16px',
      textAlign: 'left',
      listStyleType: 'none',
      padding: '0 0 0 16px',
    },
    li: {
      textIndent: '-1.1em',
    },
    label: {
      cursor: 'pointer',
    },
    checkbox: {
      cursor: 'pointer',
    },
    labelText: {
      verticalAlign: 'middle',
    },
  };

  return (
    <div style={style.div}>
      <p style={style.text}>
        <FormattedMessage id="VtourCheck.Options" />
      </p>
      <ul style={style.ul}>
        <li style={style.li}>
          <label style={style.label}>
            <input
              type="checkbox"
              style={style.checkbox}
              value={props.isCommentEnabled.value}
              onChange={props.isCommentEnabled.handleChange}
            />
            <span style={style.labelText}>
              <FormattedMessage id="VtourCheck.AllowComment" />
            </span>
          </label>
        </li>
        <li style={style.li}>
          <label style={style.label}>
            <input
              type="checkbox"
              style={style.checkbox}
              value={props.isLandmarkCommentEnabled.value}
              onChange={props.isLandmarkCommentEnabled.handleChange}
            />
            <span style={style.labelText}>
              <FormattedMessage id="VtourCheck.AllowLandmarkComment" />
            </span>
          </label>
        </li>
        <li style={style.li}>
          <label style={style.label}>
            <input
              type="checkbox"
              style={style.checkbox}
              value={props.isEmojiEnabled.value}
              onChange={props.isEmojiEnabled.handleChange}
            />
            <span style={style.labelText}>
              <FormattedMessage id="VtourCheck.AllowEmoji" />
            </span>
          </label>
        </li>
        <li style={style.li}>
          <label style={style.label}>
            <input
              type="checkbox"
              style={style.checkbox}
              value={props.isCommentListEnabled.value}
              onChange={props.isCommentListEnabled.handleChange}
            />
            <span style={style.labelText}>
              <FormattedMessage id="VtourCheck.AllowDisplayCommentList" />
            </span>
          </label>
        </li>
        <li style={style.li}>
          <label style={style.label}>
            <input
              type="checkbox"
              style={style.checkbox}
              value={props.isLocateEnabled.value}
              onChange={props.isLocateEnabled.handleChange}
            />
            <span style={style.labelText}>
              <FormattedMessage id="VtourCheck.AllowGetLocation" />
            </span>
          </label>
        </li>
      </ul>
    </div>
  );
});

export default VtourCheck;
